'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.wixDataError = wixDataError;
exports.validationError = validationError;
exports.schemaNotFoundError = schemaNotFoundError;
exports.BulkError = BulkError;

var _sharedTypeUtils = require('./shared/type-utils');

var messages = {
  siteIsInTemplateMode: function siteIsInTemplateMode() {
    return 'The current site is in template mode. Please save it to modify data.';
  },
  collectionNameMustBeAString: function collectionNameMustBeAString() {
    return 'Collection name must be a string.';
  },
  itemIdMustBeAString: function itemIdMustBeAString() {
    return 'ItemId must be a string.';
  },
  itemMustBeAnObject: function itemMustBeAnObject(item, collectionName) {
    return 'Failed to save [' + item + '] into [' + collectionName + '].\nItems must be JavaScript objects.';
  },
  itemsMustBeArrayOfObjects: function itemsMustBeArrayOfObjects(collectionName) {
    return 'Failed to bulk save items into [' + collectionName + '].\nItems must be an array of JavaScript objects and itemIds must be strings if present.';
  },
  itemsMustBeLessThanThousand: function itemsMustBeLessThanThousand(collectionName) {
    return 'Failed to bulk save items into [' + collectionName + '].\nCannot insert more than 1000 items in one request';
  },
  updateItemInvalid: function updateItemInvalid() {
    return 'Invalid update. Updated object must have a string _id property.';
  },
  invalidArgumentLength: function invalidArgumentLength(method, from, to, actual) {
    return 'wixData.' + method + ' expects between ' + from + ' and ' + to + ' arguments, but was called with ' + actual + '.';
  },
  schemaDoesNotExist: function schemaDoesNotExist(collectionName) {
    return 'The ' + collectionName + ' collection does not exist. You cannot work with a collection using the Data API before it is created in the Editor.';
  },
  collectionDeleted: function collectionDeleted(collectionName) {
    return 'The ' + collectionName + ' collection was removed, so you cannot work with it. To restore its data, create a new collection with the same name.';
  },
  permissionDenied: function permissionDenied(action, collectionName) {
    return 'The current user does not have permissions to ' + action + ' on the ' + collectionName + ' collection.';
  },
  internalError: function internalError(message) {
    return 'Internal wixData error: ' + message;
  },
  serverApiError: function serverApiError(message) {
    return message;
  },
  serverGeneralError: function serverGeneralError() {
    return 'The server could not fulfill the request.';
  },
  serverInvalidResponse: function serverInvalidResponse() {
    return 'Failed to parse server response.';
  },
  serverAuthorizationProblem: function serverAuthorizationProblem(responseJson) {
    return 'You are not authorized to access the requested resource: ' + responseJson;
  },
  serverAuthenticationProblem: function serverAuthenticationProblem() {
    return 'Authentication failed.';
  },
  internalAuthorizationProblem: function internalAuthorizationProblem() {
    return 'An internal error has occurred while trying to check authorization.';
  },
  errorConnectingToServer: function errorConnectingToServer() {
    return 'Error connecting to server.';
  },
  queryInvalid: function queryInvalid(collectionName, invalidArguments) {
    return 'Failed to perform query on [' + collectionName + '].\n' + invalidArguments.join('\n');
  },
  filterBuilderInvalid: function filterBuilderInvalid(invalidArguments) {
    return 'Failed to build a filter.\n' + invalidArguments.join('\n') + '.';
  },
  filterMustBeAnObject: function filterMustBeAnObject() {
    return 'Filter must be an object.';
  },
  sortBuilderInvalid: function sortBuilderInvalid(invalidArguments) {
    return 'Failed to build a sort.\n' + invalidArguments.join('\n') + '.';
  },
  optionsInvalid: function optionsInvalid(properties) {
    return 'Options must be an object with one or all of the following boolean properties: ' + properties.join(', ') + '.';
  },
  referenceOperationParameterError: function referenceOperationParameterError() {
    return 'Reference operation takes a string ID or an object with an ID to be connected';
  },
  multipleMultiRefIncludeError: function multipleMultiRefIncludeError() {
    return 'Unable to execute a query. Only single multi-reference field can be included.';
  },
  multiRefItemLimitError: function multiRefItemLimitError() {
    return 'Can not fetch more than 50 elements when include is being used on multi-reference field';
  },
  fieldIsDeleted: function fieldIsDeleted() {
    return 'Field is deleted';
  },
  queryValidations: {
    collectionNameIsRequired: function collectionNameIsRequired() {
      return 'Collection name is required and must be a string.';
    },
    isNumber: function isNumber(operatorName, specifier, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(operand) + ']. ' + operatorName + ' parameter must be a ' + specifier + ' number.';
    },
    isPositiveNumber: function isPositiveNumber(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a positive number.';
    },
    isNonNegativeNumber: function isNonNegativeNumber(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be a non-negative number.';
    },
    isInteger: function isInteger(operatorName, operand) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter must be an integer.';
    },
    notGreaterThan: function notGreaterThan(operatorName, operand, value) {
      return 'Invalid ' + operatorName + ' parameter [' + operand + ']. ' + operatorName + ' parameter cannot exceed ' + value + '.';
    }
  },
  arityValidations: {
    arityIsOne: function arityIsOne(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires one parameter.';
    },
    arityIsTwo: function arityIsTwo(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires two parameters.';
    },
    arityIsThree: function arityIsThree(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires three parameters.';
    },
    arityIsAtLeastTwo: function arityIsAtLeastTwo(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least two parameters.';
    },
    arityIsAtLeastOne: function arityIsAtLeastOne(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' requires at least one parameter.';
    }
  },
  filterValidations: {
    typeIsString: function typeIsString(operatorName, value) {
      return 'Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. ' + operatorName + ' parameter must be a String.';
    },
    typeIsStringNumberOrDate: function typeIsStringNumberOrDate(operatorName, value) {
      return 'Invalid ' + operatorName + ' parameter value [' + (0, _sharedTypeUtils.typeForDisplay)(value) + ']. Valid ' + operatorName + ' parameter types are String, Number or Date.';
    },
    sameType: function sameType(operatorName, first, second) {
      return 'Invalid ' + operatorName + ' parameter values [' + (0, _sharedTypeUtils.typeForDisplay)(first) + '] and [' + (0, _sharedTypeUtils.typeForDisplay)(second) + ']. Both parameters must be of the same type.';
    },
    typeIsStringNumberOrDateForAll: function typeIsStringNumberOrDateForAll(operatorName) {
      return 'Invalid ' + operatorName + ' usage. ' + operatorName + ' supports only Number, String or Date items.';
    },
    validFieldName: function validFieldName(operatorName, field) {
      return 'Invalid ' + operatorName + ' field value [' + (0, _sharedTypeUtils.typeForDisplay)(field) + ']. ' + operatorName + ' field must be a String.';
    },
    isInstanceOfSameClass: function isInstanceOfSameClass(operatorName, constructorName, obj) {
      return 'Invalid ' + operatorName + ' parameter [' + (0, _sharedTypeUtils.typeForDisplay)(obj) + ']. ' + operatorName + ' expects ' + constructorName + ' only.';
    },
    isForCollection: function isForCollection(operatorName, constructorName, collectionName) {
      return 'Invalid ' + operatorName + ' parameter query for [' + collectionName + ']. ' + operatorName + ' accepts ' + constructorName + ' for the same collection only.';
    }
  },
  sortValidations: {
    typeIsStringOrArrayOfStrings: function typeIsStringOrArrayOfStrings(operatorName, effectiveArgs) {
      return 'Invalid ' + operatorName + ' parameters [' + effectiveArgs.map(_sharedTypeUtils.typeForDisplay) + ']. Valid ' + operatorName + ' values are String, Array of String or varargs String.';
    }
  }

};

exports.messages = messages;
var codes = {
  ItemDoesNotExist: 'WD_ITEM_DOES_NOT_EXIST',
  ItemAlreadyExists: 'WD_ITEM_ALREADY_EXISTS',
  SiteInTemplateMode: 'WD_SITE_IN_TEMPLATE_MODE',
  UnknownError: 'WD_UNKNOWN_ERROR',
  ValidationError: 'WD_VALIDATION_ERROR',
  CollectionDeleted: 'WD_COLLECTION_DELETED',
  SchemaDoesNotExist: 'WD_SCHEMA_DOES_NOT_EXIST',
  PermissionDenied: 'WD_PERMISSION_DENIED'
};

exports.codes = codes;
// todo add code

function wixDataError(message, code) {
  return errorWithCode(message, code);
}

function validationError(message) {
  return errorWithCode(message, codes.ValidationError);
}

function errorWithCode(message, code) {
  var error = new Error(message);
  error.code = code;
  return error;
}

function schemaNotFoundError(collectionName) {
  return wixDataError('Failed to load schema for collection ' + collectionName, codes.SchemaDoesNotExist);
}

function BulkError(message, code, item) {
  var errorInstance = new Error(message, code);
  errorInstance.item = item;
  Object.setPrototypeOf(errorInstance, Object.getPrototypeOf(this));
  Error.captureStackTrace(errorInstance, BulkError);
  return errorInstance;
}

BulkError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/errors.js
// module id = 9
// module chunks = 0